import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Button,
    Table,
    Input,
    Card,
    CardHeader,
    CardBody,
    ModalBody,
    Modal,
} from "reactstrap";
import { Edit, Delete } from "@mui/icons-material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import firebase from "firebase";
import AddSubjectModal from "./AddSubjectModal";
import EditSubjectModal from "./EditSubjectModal"; // Import the Edit Subject Modal
import { useNavigate } from "react-router-dom";

const SubjectListing = () => {
    const navigate = useNavigate()
    const db = firebase.firestore();
    const [searchQuery, setSearchQuery] = useState("");
    const [subjects, setSubjects] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false); // State for Edit Modal
    const [selectedSubject, setSelectedSubject] = useState(null); // State to hold the subject being edited

    const toggleModal = () => setIsModalOpen(!isModalOpen);
    const toggleEditModal = () => setIsEditModalOpen(!isEditModalOpen); // Toggle for Edit Modal

    const getSubjectDetail = () => {
        db.collection("subjects")
            .where("status", "==", 0)
            .where("primaryLanguages", "!=", null)
            .get()
            .then((querySnapshot) => {
                const fetchedSubjects = [];
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    fetchedSubjects.push({
                        id: doc.id,
                        ...data,
                        topics: data.topics || [], // Ensure topics are included
                        languages: data.languages || [] // Ensure languages are included
                    });
                });
                console.log(fetchedSubjects, "fetchedSubjects");
                setSubjects(fetchedSubjects);
            })
            .catch((error) => {
                console.error("Error fetching subjects: ", error);
            });
    };

    const editSubject = async (updatedSubject) => {
        try {
            let { id, name, topics, languages } = updatedSubject;
            console.log(updatedSubject,'updatedSubject');
            // Validate required fields
            if (!id || !name || !topics.length || !languages.length) {
                throw new Error("Invalid data. Ensure all required fields are filled.");
            }
            topics = topics.map((topic) => { return topic?.trim() });
            languages = languages.map((lang) => { return lang?.toLowerCase()?.trim() });

            console.log("editCheckSubject",topics, languages);
            // Update the document in the Firestore collection
            await db.collection("subjects")
                .doc(id) // Find the document by ID
                .update({ name, topics, languages });

            // Update the subjects state
            setSubjects((prevSubjects) =>
                prevSubjects.map((subject) =>
                    subject.id === id
                        ? { ...subject, name, topics, languages }
                        : subject
                )
            );

            console.log("Subject updated successfully with ID:", id);
        } catch (error) {
            console.error("Error updating subject:", error.message);
            throw error; // Re-throw error for further handling
        }
    };


    const addSubject = (newSubject) => {
        db.collection("subjects")
            .add(newSubject)
            .then((docRef) => {
                // Add the generated document ID to the newSubject object
                const newSubjectWithId = {
                    ...newSubject,
                    id: docRef.id,  // Firestore automatically generates this id
                };

                // Update the subjects state with the new subject including its id
                setSubjects((prevSubjects) => [...prevSubjects, newSubjectWithId]);
                console.log("Subject added successfully with ID:", docRef.id);
            })
            .catch((error) => {
                console.error("Error adding subject: ", error);
            });
    };

    const handleDelete = (subjectId) => {
        const confirmed = window.confirm("Are you sure you want to delete this subject?");
        if (confirmed) {
            console.log(subjectId);
            db.collection("subjects")
                .doc(subjectId)
                .update({
                    status: 1, // Set status to 1 indicating deleted
                })
                .then(() => {
                    alert("Subject deleted successfully!");
                    getSubjectDetail(); // Refresh the list after deletion
                })
                .catch((error) => {
                    console.error("Error deleting subject: ", error);
                    alert("Error deleting subject.");
                });
        }
    };

    const handleEdit = (subject) => {
        setSelectedSubject(subject); // Set the selected subject
        toggleEditModal(); // Open Edit Modal
    };

    useEffect(() => {
        getSubjectDetail();
    }, []);

    const filteredSubjects = subjects.filter((subject) =>
        subject.name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div className="content">
            <Row>
                <Col md="12">
                    <Card>
                        <CardHeader>
                            <Row className="align-items-center">
                                <Col md="6" >
                                <div style={{display:'flex',alignItems:'center'}}>

                                    {/* <button
                                        onClick={() => navigate('/admin/quiz')}
                                        style={{
                                            marginRight: '5px',
                                            color: 'white',
                                            border: '0',
                                            padding: '0 ',
                                            outline: 'none',
                                            background: 'transparent',
                                            cursor: 'pointer',
                                            marginBottom:'14px'
                                        }}
                                    >
                                            <KeyboardBackspaceIcon style={{ fontSize: '35px', marginRight: '12px' }} />
                                    </button> */}
                                    <h3 className="card-title font-weight-bold">Subjects</h3>
                                </div>

                                </Col>
                                <Col md="6" className="text-right">
                                    <Button color="info" className="mr-2" onClick={toggleModal}>
                                        Add Subject
                                    </Button>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Row className="align-items-center mb-3">
                                <Col md="6" className="d-flex align-items-center">
                                    <Input
                                        type="text"
                                        placeholder="Search Subjects"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        className="mr-2"
                                    />
                                    <Button
                                        color="info"
                                        onClick={() => console.log("Search clicked")}
                                    >
                                        Search
                                    </Button>
                                </Col>
                            </Row>
                            {filteredSubjects.length > 0 ? (
                                <Table className="tablesorter">
                                    <thead className="text-primary">
                                        <tr>
                                            <th>Subject Name</th>
                                            <th>Topics</th>
                                            <th>Primary Language</th>
                                            <th>Languages</th>
                                            <th>Total Questions</th>
                                            <th style={{ textAlign: "center" }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredSubjects.map((subject) => (
                                            <tr key={subject.id}>
                                                <td>{subject.name}</td>
                                                <td className={subject?.primaryLanguages == 'fganh' || subject?.primaryLanguages == 'हिंदी' ? 'hinditext':''}>{subject?.primaryLanguages == 'fganh' || subject?.primaryLanguages == 'हिंदी' ? subject.topics?.join("] ") || "N/A" : subject.topics?.join(", ") || "N/A"}</td>
                                                <td>{subject.primaryLanguages || "N/A"}</td>
                                                <td>{subject.languages?.join(", ") || "N/A"}</td>
                                                <td>{subject.totalQuestions || 0}</td>
                                                <td style={{ textAlign: "center" }}>
                                                    <Edit
                                                        style={{
                                                            color: "#247cf7",
                                                            marginRight: "10px",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => handleEdit(subject)} // Open Edit Modal
                                                    />
                                                    <Delete
                                                        key={`deleteKey-${subject.id}`}
                                                        style={{ color: "red", cursor: "pointer" }}
                                                        onClick={() => handleDelete(subject.id)} // Attach delete function
                                                    />
                                                </td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </Table>
                            ) : <div style={{
                                textAlign: "center",
                                fontSize: "18px",
                                fontWeight: "bold",
                                padding: "20px",
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                marginTop: "20px"
                            }}>
                                No Subject Available
                            </div>
                            }

                        </CardBody>
                    </Card>
                </Col>
            </Row>
            {/* Add Subject Modal */}
            <Modal isOpen={isModalOpen} toggle={toggleModal}>
                <AddSubjectModal
                    isOpen={isModalOpen}
                    toggleModal={toggleModal}
                    addSubject={addSubject}
                />
            </Modal>
            {/* Edit Subject Modal */}
            <Modal isOpen={isEditModalOpen} toggle={toggleEditModal}>
                <EditSubjectModal
                    isOpen={isEditModalOpen}
                    toggleModal={toggleEditModal}
                    subjectDataToEdit={selectedSubject}
                    editSubject={editSubject}
                // Pass editSubject function to handle update
                />
            </Modal>
        </div>
    );
};

export default SubjectListing;
